import type { ComponentType } from 'react';
import type { z } from 'zod';

export interface WidgetRendererProps {
  widgetConfig: Record<string, unknown>;
  apiBaseUrl: string;
  auth?: { token?: string };
}

export interface WidgetRenderer {
  type: string;
  schema: z.ZodType;
  component: ComponentType<WidgetRendererProps>;
}

class WidgetRegistryImpl {
  private readonly renderers = new Map<string, WidgetRenderer>();

  register(widgetType: string, renderer: WidgetRenderer): void {
    this.renderers.set(widgetType, renderer);
  }

  resolve(widgetType: string): WidgetRenderer | null {
    return this.renderers.get(widgetType) ?? null;
  }

  list(): readonly WidgetRenderer[] {
    return [...this.renderers.values()];
  }
}

export const WidgetRegistry = new WidgetRegistryImpl();
